import React from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const Gift = () => {
  return (
    <div className={cx('commonBox', 'whiteTag')}>
      {/* 책갈피 */}
      <div className={cx('tagBox')}>
        <span className={cx('num')}>02.</span>
        취업 지원금 120만원
      </div>
      {/* 타이틀 */}
      <div className={cx('basicTitleInner')}>
        <span className={cx('basicTitle')}>프로필을 상세하게 작성하신 분들께</span>
        <span className={cx('subTitle')}>JOBDA가 취업지원금 총 120만원을 지원합니다!</span>
      </div>

      <span className={cx('eventInfo')}>(프로필 신규 작성 / 기존 프로필 업데이트 모두 포함)</span>

      <div className={cx('contentInner')}>
        <div className={cx('firstPrice')} />
        <span className={cx('giftInner')}>
          신세계백화점 상품권
          <br />
          <span className={cx('import')}>10만원</span>
        </span>
        <div className={cx('naverPay')}>
          <span className={cx('giftBox')}>
            네이버페이
            <strong> 5만원</strong>
          </span>
          <span className={cx('giftBox')}>
            네이버페이
            <strong> 1만원</strong>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Gift;
